import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicDatePicker from "./BasicDatePicker";
import DateRangePickerComponent from "./DateRangePickerComponent";

const DatePickerPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox title={"Date Picker"} description={""} />
      <Divider light />
        <DateRangePickerComponent />
        <BasicDatePicker />
    </Paper>
  );
};

export default DatePickerPage;
